//* Libraries imports
import { motion } from 'framer-motion';
import { Card } from 'react-bootstrap';

//* Components imports
import Icon from "../../../../components/common/Icon";

//* Icons imports
import { MdDescription, MdInfo } from 'react-icons/md';

//* Styles imports
import './edital-content.scss';

interface EditalContentProps {
  rules: string;
}

export function EditalContent({ rules }: EditalContentProps) {
  return (
    <motion.div
      className="container-fluid px-3 py-4"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.3 }}
    >
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10 col-xl-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <Card className="shadow-lg edital-content-card">
              <Card.Header className="bg-primary text-white">
                <div className="d-flex align-items-center">
                  <Icon icon={MdDescription} className="me-2" size={20} />
                  <h4 className="mb-0">Regras e Informações do Edital</h4>
                </div>
              </Card.Header>
              
              <Card.Body className="p-4">
                <div className="mb-3">
                  <div className="d-flex align-items-center text-info mb-2">
                    <Icon icon={MdInfo} className="me-2" size={16} />
                    <small className="fw-bold">
                      Leia atentamente todas as informações abaixo
                    </small>
                  </div>
                </div>

                <motion.div
                  className="edital-rules-content"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.7, delay: 0.6 }}
                  dangerouslySetInnerHTML={{ __html: rules }}
                />
              </Card.Body>
            </Card>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
}
